import './index.scss';
import LogoS from '../../../assets/images/logo-s.png';
import { useRef } from 'react';
import { useEffect } from 'react';
import gsap from 'gsap-trial';
// import { DrawSVGPlugin } from 'gsap-trial/DrawSVGPlugin';
import { motion } from "framer-motion";
const Logo = () => {
  const pathVariants = {
    hidden: {
      pathLength: 0
    },
    visible: {
      pathLength: 4,
      transition: {
        duration: 30,
      }
    }
  }
  const bgRef = useRef();
  const outlineLogoRef = useRef();
  const solidLogoRef = useRef();

  useEffect(() => {
    // gsap.registerPlugin(DrawSVGPlugin)
    gsap.timeline()
      .to(bgRef.current, { duration: 1, opacity: 1, })

    gsap.fromTo(solidLogoRef.current, { opacity: 0 }, { duration: 4, opacity: 1, delay: 4 })
  }, [])
  return (
    <div className="logo-container" ref={bgRef}>
      <img ref={solidLogoRef} src={LogoS} alt="A" className="solid-logo" />
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="100%" height="100%" viewBox="0 0 436 477" fill="none"
        preserveAspectRatio="xMidYMid meet">
        <g
          className='svg-container'>
          <motion.path ref={outlineLogoRef}
            // d="M200 2H259.5L433 475H373.5M200 2L26.5 475M200 2H176.5L2.5 475H26.5M373.5 475L325.5 341.5H301M373.5 475H348.5L301 341.5M26.5 475H86.5L133.5 341.5H301M283.5 290.5H307.5L231.5 77H228L217.5 105.5M283.5 290.5L217.5 105.5M283.5 290.5L152 290L217.5 105.5" strokeWidth="3"
            // d="M198.5 1H177M198.5 1L25.1834 473.5M198.5 1H201.5M258 1L431.5 474M258 1H201.5M258 1L260.5 1.5L434 474H431.5M431.5 474H372M372 474L324 340.5H299.5M372 474H347L299.5 340.5M25 474H85L132 340.5H299.5M25 474H1L175 1H177M25 474L25.1834 473.5M230 76H226.5L216 104.5M230 76L306 289.5M230 76H232.5L308.5 289.5H306M230 76L219 104.5M306 289.5H284.5M282 289.5L216 104.5M282 289.5H284.5M282 289.5L153 289.009M216 104.5L150.5 289L153 289.009M177 1L4 473L25.1834 473.5M201.5 1L28 473H88L135.5 339.5H326L373.5 473.5M302.5 341L349.5 473.5M219 104.5L284.5 289.5M219 104.5L153 289.009" stroke="#CB0723" strokeWidth="1"
            d="M198.5 1L25.1834 473.5M198.5 1H201.5M198.5 1H175L1 474H25M258 1L431.5 474M258 1H201.5M258 1L260.5 1.5M431.5 474H372M431.5 474H434L260.5 1.5M372 474L324 340.5H299.5M372 474H347L299.5 340.5M25 474H85L132 340.5H299.5M25 474L25.1834 473.5M230 76H226.5L216 104.5M230 76L306 289.5H284.5M230 76H232.5L308.5 289.5M230 76L219 104.5M282 289.5L216 104.5M282 289.5H284.5M282 289.5L153 289.009M282 289.5L308.5 290H150.5M216 104.5L150.5 289L153 289.009M25.1834 473.5L4 473L176.5 2.5L260.5 1.5M201.5 1L28 473H88L135.5 339.5H326L373.5 473.5M302.5 341L349.5 473.5M219 104.5L284.5 289.5M219 104.5L153 289.009"
            variants={pathVariants}
            initial="hidden"
            animate="visible"
          />
        </g>
      </svg>
    </div>
  )
}
export default Logo;